import axios from "axios";

export const state = {
    enrollments: [],
};

export const getters = {
    enrollments: state => state.enrollments,
};

export const mutations = {
    setEnrollments(state, newValue) {
        state.enrollments = newValue
    },
};

export const actions = {
    fetchEnrollments({ commit }) {
        axios.get('/enrollments').then(res => {
            commit('setEnrollments', res.data.enrollments);
        })
    },
    filterEnrollments({commit}, {schoolterm,year}) { 
        let formData = new FormData();
        formData.append("schoolterm", schoolterm);
        formData.append("year", year);
        let url = "/filterenrollments";
        axios.post(url, formData).then((response) => {
            commit('setEnrollments', response.data.enrollments)
        })
    },
};
